module.exports = __webpack_public_path__ + "static/Motor_Render-35acd6aa8d08a2e5d64b7a5bdd35e1ca.png";